import { mp } from './mortgage';
export function amor(s) {
  const out = [];
  let bal = s.mortAmt;
  const mr = s.mortRate / 12;
  const mpay = mp(s.mortAmt, s.mortRate, s.amortYrs);
  let hv = s.hPrice;
  for (let y = 0; y <= s.amortYrs; y++) {
    hv = y ? hv * (1 + s.hApp) : s.hPrice;
    out.push({ a: s.hAge + y, b: Math.round(bal), e: Math.round(hv - bal), h: Math.round(hv) });
    for (let m = 0; m < 12 && bal > 0; m++) bal = Math.max(0, bal - (mpay - bal * mr));
    bal = Math.max(0, bal - s.xPrin);
  }
  return out;
}
